import * as StringHelpers from '@core/helper/string';
var i18nPlugin = /** @class */ (function () {
    function i18nPlugin() {
    }
    i18nPlugin.install = function (Vue) {
        for (var funcName in django) {
            Vue.prototype["$".concat(funcName)] = django[funcName];
        }
        Vue.prototype.$django = django;
        Vue.prototype.$format = StringHelpers.format;
        Vue.prototype.$escape = StringHelpers.escape;
    };
    return i18nPlugin;
}());
export default i18nPlugin;
